import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';

import {
  unmuteAccount,
  unblockAccount,
} from '../actions/accounts';
import { initBlockModal } from '../actions/blocks';
import {
  replyCompose,
  mentionCompose,
  directCompose, replyCommentCompose,
  shareDetailCompose,
} from '../actions/compose';
import {
  initDomainBlockModal,
  unblockDomain,
} from '../actions/domain_blocks';
import {
  initAddFilter,
} from '../actions/filters';
import {
  toggleReblog,
  toggleFavourite,
  bookmark,
  unbookmark,
  pin,
  unpin,
} from '../actions/interactions';
import { openModal } from '../actions/modal';
import { initMuteModal } from '../actions/mutes';
import { deployPictureInPicture } from '../actions/picture_in_picture';
import { initReport } from '../actions/reports';
import {
  muteStatus,
  unmuteStatus,
  deleteStatus,
  toggleStatusSpoilers,
  toggleStatusCollapse,
  editStatus,
  translateStatus,
  undoStatusTranslation,
  editComment,
} from '../actions/statuses';
import Status from '../components/status';
import { deleteModal } from '../initial_state';
import { makeGetStatus, makeGetPictureInPicture } from '../selectors';

const makeMapStateToProps = () => {
  const getStatus = makeGetStatus();
  const getPictureInPicture = makeGetPictureInPicture();

  const mapStateToProps = (state, props) => {
    return {
      status: getStatus(state, props),
      nextInReplyToId: props.nextId ? state.getIn(['statuses', props.nextId, 'in_reply_to_id']) : null,
      pictureInPicture: getPictureInPicture(state, props),
      commentId: state.getIn(['commentForm', 'commentId'])
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = (dispatch, { contextType }) => ({

  onReply(status) {
    dispatch(() => {
      dispatch(replyCompose(status));
    });
  },

  onReplyComment(status) {
    dispatch(() => {
      dispatch(replyCommentCompose(status));
    });
  },

  onReblog(status, e) {
    dispatch(toggleReblog(status.get('id'), e.shiftKey));
  },

  onFavourite(status) {
    dispatch(toggleFavourite(status.get('id')));
  },

  onBookmark(status) {
    if (status.get('bookmarked')) {
      dispatch(unbookmark(status));
    } else {
      dispatch(bookmark(status));
    }
  },

  onPin(status) {
    if (status.get('pinned')) {
      dispatch(unpin(status));
    } else {
      dispatch(pin(status));
    }
  },

  onEmbed(status) {
    dispatch(openModal({
      modalType: 'EMBED',
      modalProps: { id: status.get('id') },
    }));
  },

  onDelete(status, withRedraft = false, isComment = false) {
    const statusOriginId = window.location.pathname.split("/").pop();

    if (!deleteModal) {
      dispatch(deleteStatus(status.get('id'), withRedraft, statusOriginId));
    } else {
      dispatch(openModal({ modalType: 'CONFIRM_DELETE_STATUS', modalProps: { statusId: status.get('id'), withRedraft, isComment, statusOriginId}}));
    }
  },

  onEdit(status) {
    dispatch((_, getState) => {
      dispatch(editStatus(status.get('id')));
    });
  },

  onEditComment(status) {
    dispatch((_, getState) => {
      dispatch(editComment(status.get('id')));
    });
  },

  onTranslate(status) {
    if (status.get('translation')) {
      dispatch(undoStatusTranslation(status.get('id'), status.get('poll')));
    } else {
      dispatch(translateStatus(status.get('id')));
    }
  },

  onDirect(account) {
    dispatch(directCompose(account));
  },

  onMention(account) {
    dispatch(mentionCompose(account));
  },

  onOpenMedia(statusId, media, index, lang) {
    dispatch(openModal({
      modalType: 'MEDIA',
      modalProps: { statusId, media, index, lang },
    }));
  },

  onOpenVideo(statusId, media, lang, options) {
    dispatch(openModal({
      modalType: 'VIDEO',
      modalProps: { statusId, media, lang, options },
    }));
  },

  onBlock(status) {
    const account = status.get('account');
    dispatch(initBlockModal(account));
  },

  onUnblock(account) {
    dispatch(unblockAccount(account.get('id')));
  },

  onReport(status) {
    dispatch(initReport(status.get('account'), status));
  },

  onAddFilter(status) {
    dispatch(initAddFilter(status, { contextType }));
  },

  onMute(account) {
    dispatch(initMuteModal(account));
  },

  onUnmute(account) {
    dispatch(unmuteAccount(account.get('id')));
  },

  onMuteConversation(status) {
    if (status.get('muted')) {
      dispatch(unmuteStatus(status.get('id')));
    } else {
      dispatch(muteStatus(status.get('id')));
    }
  },

  onToggleHidden(status) {
    dispatch(toggleStatusSpoilers(status.get('id')));
  },

  onToggleCollapsed(status, isCollapsed) {
    dispatch(toggleStatusCollapse(status.get('id'), isCollapsed));
  },

  onBlockDomain(account) {
    dispatch(initDomainBlockModal(account));
  },

  onUnblockDomain(domain) {
    dispatch(unblockDomain(domain));
  },

  shareDetailCompose(status) {
    dispatch(shareDetailCompose(status));
  },

  deployPictureInPicture(status, type, mediaProps) {
    dispatch(deployPictureInPicture({ statusId: status.get('id'), accountId: status.getIn(['account', 'id']), playerType: type, props: mediaProps }));
  },

  onInteractionModal(type, status) {
    dispatch(openModal({
      modalType: 'INTERACTION',
      modalProps: {
        type,
        accountId: status.getIn(['account', 'id']),
        url: status.get('uri'),
      },
    }));
  },

});

export default injectIntl(connect(makeMapStateToProps, mapDispatchToProps)(Status));
